import React from 'react';
import Extendable from './Extendable'
import {formatDate, formatDateIntl} from '../DateUtil'

const Subscriptionable = {
  assignedToText: (subscription, displayText) => {
    displayText ||= subscription.assignedToEmail
    if (["ready", "delayed_start", "section_ended", "expired", "section_not_started"].indexOf(subscription.status) != -1) {
      return displayText
    } else if (subscription.isEnrolled && subscription.error) {
      return displayText
    }
  },
  startAtText: (subscription, subscriptionCodes) => {
    if (["ready", "section_ended", "expired"].indexOf(subscription.status) != -1) {
      return (<span title={formatDateIntl(subscription.startAtDate, true)}>{subscription.startAt}</span>)
    } else if (subscription.isEnrolled && subscription.error) {
      return subscription.startAt
    } else if (["not_assigned", "delayed_start"].indexOf(subscription.status) != -1) {
      return 'Not started'
    } else if (["disabled", "section_not_started"].indexOf(subscription.status) != -1) {
      return ''
    } else if (!subscription.isEnrolled && !subscription.isThirdParty(subscriptionCodes)) {
      return 'Not started'
    } else if (!subscription.isEnrolled && subscription.isThirdParty(subscriptionCodes) && subscription.lineItemIndex(subscriptionCodes)) {
      return `Subscription Code ${subscription.lineItemIndex(subscriptionCodes)}:`
    } else if (!subscription.isEnrolled && subscription.isThirdParty(subscriptionCodes) && !subscription.lineItemIndex(subscriptionCodes)) {
      return 'Subscription Code :'
    }
  },
  monthlySubscription: (subscription, lineItemsExtension) => {
    if (subscription.isEnrolled) {
      const extension = Extendable.extension(lineItemsExtension, subscription.enrollment)
      if (extension) {
        return extension
      }
    }
    if (subscription.isMonthly) {
      return subscription
    }
    return null
  },
  endAtText: (subscription, lineItemsExtension, opts) => {
    opts ||= {}
    opts.formatDate ||= formatDate
    const monthlySubscription = Subscriptionable.monthlySubscription(subscription, lineItemsExtension)
    if (monthlySubscription) {
      if (subscription.isMonthly) {
        return opts.subscriptionText || (<span status="is_recur"></span>)
      } else {
        return opts.subscriptionText || (<span status="has_extension"></span>)
      }
    } else {
      if (["ready", "section_ended", "expired"].indexOf(subscription.status) != -1) {
        return (<span title={formatDateIntl(subscription.endAt, true)}>{`${opts.prefix || ''}${opts.formatDate(subscription.endAt)}`}</span>)
      } else if (subscription.isEnrolled && subscription.error) {
        return opts.formatDate(subscription.endAt)
      } else {
        return ''
      }
    }
  },
  goToCourseUrl: (subscription, lineItemsExtension, host, customer, shop_name) => {
    // shopper#406 : mark recurring subscriptions as expired after 30 days if max_payments exists and not reached
    const goToCourseUrlBase = subscription.isEnrolled && `${host}/accounts/goto_course?enrollment_id=${subscription.enrollmentId}&cid=${customer.id}&shop_name=${shop_name}`
    if (subscription.needsPayment) {
      return ''
    } else if (["ready"].indexOf(subscription.status) != -1) {
      return goToCourseUrlBase
    } else if (["delayed_start"].indexOf(subscription.status) != -1) {
      return `${goToCourseUrlBase}&start=1`
    } else if (Extendable.hasActiveExtension(lineItemsExtension, subscription.enrollment)) {
      // shopper#417 : allow access if active extension exists
      return `${goToCourseUrlBase}&extension=1`
    }
  },
  goToCourseText: (subscription, lineItemsExtension, subscriptionCodes) => {
    if (Extendable.hasActiveExtension(lineItemsExtension, subscription.enrollment)) {
      return ''
    } else if (["section_ended", "expired"].indexOf(subscription.status) != -1) {
      return (<span status={subscription.status}>Ended</span>)
    } else if (subscription.needsPayment) {
      return (<span status="needsPayment">Ended</span>)
    } else if (["section_not_started"].indexOf(subscription.status) != -1) {
      return `Starts on ${Subscriptionable.startAt(subscription)}`
    } else if (["disabled"].indexOf(subscription.status) != -1) {
      return "Inactive"
    } else if (!subscription.isEnrolled && subscription.isThirdParty(subscriptionCodes)) {
      return subscription.code(subscriptionCodes)
    } else {
      return ''
    }
  },
  startAt: (subscription, sections) => {
    let result;
    if (subscription.isInstructorCourse) {
      const section = sections && sections.find && sections.find((section) => section.sku == subscription.sku)
      result = section && formatDate(section.start_at)
    }
    result = result || subscription.startAt
    return result
  },
  allowLoginAsStudentFlags: (subscription, user) => {
    const results = []
    // shopper#632 : only allow enrollment exists
    if (!subscription.enrollment) {
      results.push('no_enrollment')
    }
    // shopper#632 : only allow if enrollment is assigned
    if (subscription.enrollment && !subscription.enrollment.isAssigned) {
      results.push('enrollment_not_assigned')
    }
    // shopper#632 : only allow if user is owner of the enrollment
    if (subscription.enrollment && subscription.enrollment.ownedByOther(user)) {
      results.push('user_not_owner')
    }
    // shopper#632 : only allow if user is not the assignee of the enromment
    if (subscription.enrollment && subscription.enrollment.isAssignedToUser(user)) {
      results.push('user_is_assigned')
    }
    return results
  },
  allowLoginAsParentFlags: (subscription, user) => {
    const results = []
    // shopper#632 : only allow enrollment exists
    if (!subscription.enrollment) {
      results.push('no_enrollment')
    }
    // shopper#632 : only allow if user is not the owner of the enromment
    if (subscription.enrollment && subscription.enrollment.ownedByUser(user)) {
      results.push('user_is_owner')
    }
    return results
  }

}

export default Subscriptionable
